import angular from 'angular';
import tableComponent from './table.component';

let tableModule = angular.module('table', [])

.component('tableApp', tableComponent)

.name;

export default tableModule;



// WEBPACK FOOTER //
// ./client/app/components/table/table.js